import _classCallCheck from "/Users/songzhou/Desktop/contact-form/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/Users/songzhou/Desktop/contact-form/node_modules/@babel/runtime/helpers/esm/createClass.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.typed-array.uint8-array.js";
import "core-js/modules/es.typed-array.at.js";
import "core-js/modules/es.typed-array.copy-within.js";
import "core-js/modules/es.typed-array.every.js";
import "core-js/modules/es.typed-array.fill.js";
import "core-js/modules/es.typed-array.filter.js";
import "core-js/modules/es.typed-array.find.js";
import "core-js/modules/es.typed-array.find-index.js";
import "core-js/modules/es.typed-array.for-each.js";
import "core-js/modules/es.typed-array.includes.js";
import "core-js/modules/es.typed-array.index-of.js";
import "core-js/modules/es.typed-array.iterator.js";
import "core-js/modules/es.typed-array.join.js";
import "core-js/modules/es.typed-array.last-index-of.js";
import "core-js/modules/es.typed-array.map.js";
import "core-js/modules/es.typed-array.reduce.js";
import "core-js/modules/es.typed-array.reduce-right.js";
import "core-js/modules/es.typed-array.reverse.js";
import "core-js/modules/es.typed-array.set.js";
import "core-js/modules/es.typed-array.slice.js";
import "core-js/modules/es.typed-array.some.js";
import "core-js/modules/es.typed-array.sort.js";
import "core-js/modules/es.typed-array.subarray.js";
import "core-js/modules/es.typed-array.to-locale-string.js";
import "core-js/modules/es.typed-array.to-string.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.error.cause.js";
// Copyright 2021-2022 @skyekiwi/crypto authors & contributors
// SPDX-License-Identifier: Apache-2.0
import { box, randomBytes } from 'tweetnacl';
export var AsymmetricEncryption = /*#__PURE__*/function () {
  function AsymmetricEncryption() {
    _classCallCheck(this, AsymmetricEncryption);
  }

  _createClass(AsymmetricEncryption, null, [{
    key: "getPublicKey",
    value:
    /**
      * get a curve25519 publicKey from a secretKey
      * @param {Uint8Array} secretKey a 32 bytes secretKey on curve25519
      * @returns {Uint8Array} a 32 bytes publicKey on curve25519
    */
    function getPublicKey(secretKey) {
      return box.keyPair.fromSecretKey(secretKey).publicKey;
    }
    /**
      * encrypt a message on curve25519
      * @param {Uint8Array} key a 32 bytes secretKey on curve25519
      * @param {Uint8Array} message message to be encrypt
      * @param {Uint8Array} receiverPublicKey a 32 bytes publicKey on curve25519 of the receiver
      * @returns {Uint8Array} full encrypted message: nonce + encrypted message
    */

  }, {
    key: "encrypt",
    value: function encrypt(message, receiverPublicKey) {
      var ephmeralKey = randomBytes(32);
      var authorKey = AsymmetricEncryption.getPublicKey(ephmeralKey);
      var nonce = randomBytes(box.nonceLength);
      var encrypted = box(message, nonce, receiverPublicKey, ephmeralKey);
      var fullMessage = new Uint8Array(nonce.length + encrypted.length + authorKey.length);
      fullMessage.set(authorKey);
      fullMessage.set(nonce, authorKey.length);
      fullMessage.set(encrypted, nonce.length + authorKey.length);
      return fullMessage;
    }
    /**
      * decrypt a message on curve25519
      * @param {Uint8Array} privateKey a 32 bytes secretKey on curve25519
      * @param {Uint8Array} messageWithNonce full encrypted message with nonce at the first 24 bytes
      * @param {Uint8Array} senderPublicKey a 32 bytes publicKey on curve25519 of the sender
      * @returns {Uint8Array} decrypted message
    */

  }, {
    key: "decrypt",
    value: function decrypt(privateKey, messageWithNonce) {
      var authorKey = messageWithNonce.slice(0, box.publicKeyLength);
      var nonce = messageWithNonce.slice(box.publicKeyLength, box.publicKeyLength + box.nonceLength);
      var message = messageWithNonce.slice(box.publicKeyLength + box.nonceLength //, messageWithNonce.length
      );
      var decrypted = box.open(message, nonce, authorKey, privateKey);

      if (!decrypted) {
        throw new Error('decryption failed - Box.decrypt');
      }

      return decrypted;
    }
  }]);

  return AsymmetricEncryption;
}();